import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild} from '@angular/core';
import {FormControl, UntypedFormBuilder, UntypedFormGroup, Validators} from "@angular/forms";
import {ModalComponent} from "@components/index";
import {ToolPosition} from '@app/tool/model/tool-position.model';
import {Tool} from '@app/tool/model/tool.model';
import {TranslateService} from "@ngx-translate/core";

@Component({
    selector: 'app-tool-position-modal',
    templateUrl: './tool-position-modal.component.html',
    styleUrls: ['./tool-position-modal.component.scss']
})
export class ToolPositionModalComponent implements OnInit, OnChanges {
    @ViewChild(ModalComponent, {static: true}) modal: ModalComponent;

    @Input() tool: Tool;
    @Input() positions: ToolPosition[];
    @Input() userIdentity: string;
    @Input() hasReset = false;
    @Input() hasSpare = false;

    @Output() assign = new EventEmitter<any>();
    @Output() resetPosition = new EventEmitter<any>();

    positionForm: UntypedFormGroup;

    showValidations = false;

    constructor(private formBuilder: UntypedFormBuilder,
                private translateService: TranslateService) {
    }

    ngOnInit() {
        this.positionForm = this.formBuilder.group({
            'position': [null, Validators.required],
            'spare': new FormControl(false)
        });
    }

    open() {
        this.modal.open();
    }

    reset() {
        this.positionForm.reset();
    }

    close() {
        this.modal.close();
    }

    onConfirm() {
        if (!this.positionForm.valid) {
            this.showValidations = true;
            return;
        }
        this.showValidations = false;

        const formData = Object.assign(
            {},
            this.positionForm.value,
        );
        formData.tool = this.tool;
        formData.spare = !!formData.spare;
        this.assign.emit(formData);
    }

    onResetPosition() {
        this.positions.forEach(item => item.selected = false);
        this.resetPosition.emit({
            tool: this.tool,
            spare: !!this.positionForm.value.spare
        });
    }

    mapSlots(positions: ToolPosition[]) {
        return positions.map(position => {
            return {label: position.slot.label, value: position, selected: position.selected}
        })
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['positions'] && this.positionForm) {
            this.positionForm.get('position')
                .patchValue(this.positions.filter(position => position.selected)[0]);
        }

        if (changes['tool'] && this.positionForm && this.tool) {
            this.positionForm.get('spare').patchValue(this.tool.isSpare);
        }
    }

    computeTitle() {
        const toolName = this.tool ? this.tool.name : 'N/A';

        if (!this.positions || this.positions.length === 0) {
            return this.translateService.instant('admin.lifts.assign.noPositionToAssign', {tool: toolName});
        }

        if (this.hasReset) {
            return this.translateService.instant('admin.lifts.assign.assignToolWithReset', {tool: toolName});
        }

        return this.translateService.instant('admin.lifts.assign.assignTool', {tool: toolName});
    }

    showAssignButton() {
        return this.positions && this.positions.length !== 0
    }

    showResetButton() {
        return this.positions && this.positions.length !== 0 && this.hasReset;
    }

    canBeMarkedAsSpare() {
        return this.hasSpare && !this.tool?.isSpare && this.positions && this.positions.length !== 0;
    }
}
